import "./styles.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MoviesGrid from "./components/MoviesGrid";
import Watchlist from "./components/Watchlist";
import { HashRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";

function App() {
  const [movies, setMovies] = useState([]);
  const [watchlist, setWatchlist] = useState([]);
  const [genres, setGenres] = useState({});
  const [page, setPage] = useState(1); // ✅ track current page

  const API_KEY = process.env.REACT_APP_TMDB_API_KEY;

  // ✅ Load genres from TMDB
  useEffect(() => {
    fetch(
      `https://api.themoviedb.org/3/genre/movie/list?api_key=${API_KEY}&language=en-US`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.genres) {
          const genreMap = {};
          data.genres.forEach((g) => {
            genreMap[g.id] = g.name;
          });
          setGenres(genreMap);
        }
      })
      .catch((err) => console.error("Error fetching genres:", err));
  }, [API_KEY]);

  // ✅ Fetch movies by page (wrapped in useCallback)
  const loadMovies = useCallback(
    (pageNum) => {
      fetch(
        `https://api.themoviedb.org/3/movie/popular?api_key=${API_KEY}&language=en-US&page=${pageNum}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (pageNum === 1) {
            setMovies(data.results || []);
          } else {
            setMovies((prev) => [...prev, ...(data.results || [])]);
          }
        })
        .catch((err) => console.error("Error fetching movies:", err));
    },
    [API_KEY] // ✅ stable dependency
  );

  // ✅ Load first page initially
  useEffect(() => {
    loadMovies(1);
  }, [loadMovies]);

  // ✅ Load watchlist from localStorage on first render
  useEffect(() => {
    const savedWatchlist = JSON.parse(localStorage.getItem("watchlist")) || [];
    setWatchlist(savedWatchlist);
  }, []);

  // ✅ Save watchlist to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("watchlist", JSON.stringify(watchlist));
  }, [watchlist]);

  // ✅ Toggle add/remove watchlist
  const toggleWatchlist = (movieId) => {
    setWatchlist((prev) =>
      prev.includes(movieId)
        ? prev.filter((id) => id !== movieId)
        : [...prev, movieId]
    );
  };

  // ✅ Handle load more
  const loadMoreMovies = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    loadMovies(nextPage);
  };

  return (
    <div className="App">
      <div className="container">
        <Header />

        <Router>
          <nav>
            <ul>
              <li>
                <NavLink to="/" end>
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink to="/watchlist">Watchlist</NavLink>
              </li>
            </ul>
          </nav>

          <Routes>
            <Route
              path="/"
              element={
                <MoviesGrid
                  movies={movies}
                  setMovies={setMovies} // ✅ added
                  watchlist={watchlist}
                  toggleWatchlist={toggleWatchlist}
                  genres={genres}
                  loadMoreMovies={() => loadMovies(page + 1)}
                />
              }
            />
            <Route
              path="/watchlist"
              element={
                <Watchlist
                  movies={movies}
                  watchlist={watchlist}
                  toggleWatchlist={toggleWatchlist}
                  genres={genres}
                />
              }
            />
          </Routes>
        </Router>
      </div>
      <Footer />
    </div>
  );
}

export default App;
